module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "live-monitor"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("约课管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("实时监课")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "lm-toolbar"
  }, [_c('input', {
    staticClass: "lm-autofill-trap",
    attrs: {
      "tabindex": "-1",
      "autocomplete": "off",
      "name": "lm-autofill-trap"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "lm-field"
  }, [_c('span', {
    staticClass: "lm-label"
  }, [_vm._v("学生")]), _vm._v(" "), _c('Select', {
    ref: "stuSelect",
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "filterable": "",
      "remote": "",
      "multiple": "",
      "clearable": "",
      "transfer": "",
      "remote-method": _vm.remoteStudent,
      "loading": _vm.studentLoading,
      "placeholder": "学生姓名 / 手机号 / ID，可多选"
    },
    on: {
      "on-change": _vm.onStudentChange
    },
    model: {
      value: (_vm.selectedUids),
      callback: function($$v) {
        _vm.selectedUids = $$v
      },
      expression: "selectedUids"
    }
  }, _vm._l((_vm.studentOptions), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v("\n          " + _vm._s(item.id) + " - " + _vm._s(item.nickname) + " - " + _vm._s(item.mobile) + "\n        ")])
  }), 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "lm-field"
  }, [_c('span', {
    staticClass: "lm-label"
  }, [_vm._v("课程类型")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "clearable": "",
      "transfer": "",
      "placeholder": "全部"
    },
    on: {
      "on-change": _vm.onLsnTypeChange
    },
    model: {
      value: (_vm.lsnType),
      callback: function($$v) {
        _vm.lsnType = _vm._n($$v)
      },
      expression: "lsnType"
    }
  }, [_c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("常规课")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("体验课")])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "lm-field"
  }, [_c('span', {
    staticClass: "lm-label"
  }, [_vm._v("老师")]), _vm._v(" "), _c('Input', {
    ref: "tchInput",
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "name": "lmTchKey",
      "autocomplete": "off",
      "clearable": "",
      "placeholder": "老师 ID / 姓名，回车搜索"
    },
    on: {
      "on-enter": _vm.fetchLessons,
      "on-clear": _vm.fetchLessons
    },
    model: {
      value: (_vm.tchKey),
      callback: function($$v) {
        _vm.tchKey = $$v
      },
      expression: "tchKey"
    }
  })], 1), _vm._v(" "), (_vm.canFilterMine) ? _c('span', {
    staticClass: "lm-field"
  }, [_c('span', {
    staticClass: "lm-label"
  }, [_vm._v("只看我的学生")]), _vm._v(" "), _c('i-switch', {
    on: {
      "on-change": _vm.onOnlyMineChange
    },
    model: {
      value: (_vm.onlyMine),
      callback: function($$v) {
        _vm.onlyMine = $$v
      },
      expression: "onlyMine"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "lm-field"
  }, [_c('span', {
    staticClass: "lm-label"
  }, [_vm._v("进入自动播放")]), _vm._v(" "), _c('i-switch', {
    on: {
      "on-change": _vm.onAutoPlayChange
    },
    model: {
      value: (_vm.autoPlay),
      callback: function($$v) {
        _vm.autoPlay = $$v
      },
      expression: "autoPlay"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "lm-field"
  }, [_c('span', {
    staticClass: "lm-label"
  }, [_vm._v("同时播放数")]), _vm._v(" "), _c('InputNumber', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "min": 1,
      "max": _vm.playLimitMax
    },
    on: {
      "on-change": _vm.onPlayLimitChange
    },
    model: {
      value: (_vm.playLimit),
      callback: function($$v) {
        _vm.playLimit = $$v
      },
      expression: "playLimit"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "lm-field"
  }, [_c('span', {
    staticClass: "lm-label"
  }, [_vm._v("一行几个")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "transfer": ""
    },
    on: {
      "on-change": _vm.onColsChange
    },
    model: {
      value: (_vm.colsPerRow),
      callback: function($$v) {
        _vm.colsPerRow = _vm._n($$v)
      },
      expression: "colsPerRow"
    }
  }, [_c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("自适应")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 4
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 5
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 6
    }
  }, [_vm._v("6")])], 1)], 1), _vm._v(" "), (_vm.hiddenLessons.length) ? _c('span', {
    staticClass: "lm-field"
  }, [_c('Dropdown', {
    attrs: {
      "trigger": "click",
      "transfer": ""
    },
    on: {
      "on-click": _vm.onHiddenClick
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("\n          未展示 " + _vm._s(_vm.hiddenLessons.length) + "\n          "), _c('Icon', {
    attrs: {
      "type": "arrow-down-b"
    }
  })], 1), _vm._v(" "), _c('Dropdown-menu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, _vm._l((_vm.hiddenLessons), function(item) {
    return _c('Dropdown-item', {
      key: item.id,
      attrs: {
        "name": String(item.id)
      }
    }, [_vm._v("\n            " + _vm._s(_vm.hiddenLabel(item)) + "\n          ")])
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "lm-field"
  }, [_vm._l((_vm.hiddenLessons.slice(0, 3)), function(item) {
    return _c('Tag', {
      key: 'tag-' + item.id,
      nativeOn: {
        "click": function($event) {
          return _vm.replaceWithLesson(item)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.userNickname || item.uid) + "\n      ")])
  }), _vm._v(" "), (_vm.hiddenLessons.length > 3) ? _c('span', {
    staticClass: "lm-more"
  }, [_vm._v("等 " + _vm._s(_vm.hiddenLessons.length) + " 堂未展示")]) : _vm._e()], 2), _vm._v(" "), _c('span', {
    staticClass: "lm-field"
  }, [_c('Button', {
    on: {
      "click": _vm.resetLayout
    }
  }, [_vm._v("重置布局")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading,
      "icon": "refresh"
    },
    on: {
      "click": _vm.fetchLessons
    }
  }, [_vm._v("刷新")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "lm-hint"
  }, [_vm._v("可监课时间：体验课课前 " + _vm._s(_vm.trialBeforeMin) + " 分钟、课后 " + _vm._s(_vm.trialAfterMin) + " 分钟；常规课课前 " + _vm._s(_vm.regularBeforeMin) + " 分钟、课后 " + _vm._s(_vm.regularAfterMin) + " 分钟")]), _vm._v(" "), (!_vm.loading && !_vm.allLessons.length) ? _c('div', {
    staticClass: "lm-empty"
  }, [_vm._v("当前没有可监课的课程")]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "canvas",
    staticClass: "lm-canvas",
    style: ({
      minHeight: _vm.canvasMinHeight + 'px'
    })
  }, _vm._l((_vm.windows), function(win) {
    return _c('live-monitor-window', {
      key: win.id,
      attrs: {
        "win": win
      },
      on: {
        "play": _vm.playWin,
        "pause": _vm.pauseWin,
        "focus": _vm.focusWin,
        "maximize": _vm.maximizeWin,
        "restore": _vm.restoreWin,
        "open-external": _vm.openExternal
      }
    })
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75888efa","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lesson/LiveMonitor.vue
// module id = 1871
// module chunks = 8